<template>
  <el-popover
    placement="bottom"
    width="210"
    trigger="click"
    popper-class="patient-poper"
    v-model="visible"
  >
    <div>
      <el-input
        v-model="keywords"
        size="mini"
        class="search-input"
        placeholder="search"
      ></el-input>
      <img
        class="search-icon"
        src="../assets/search-list.svg"
        @click="search"
      />
      <div class="patient-item-wrapper" v-if="manufacturers.length">
        <div
          class="patient-item"
          v-for="(manufacturer, index) in manufacturers"
          :key="index"
          @click="selectManufacturer(manufacturer)"
        >
          <div>
            <img
              class="circle-img mr-20"
              :src="manufacturer.avatarUrl"
              v-if="manufacturer.avatarUrl"
            />
            <div v-else class="mr-20 grey-circle v-h-center">
              <img src="../assets/picture_white.svg" />
            </div>
          </div>
          <div>
            <div class="name">{{ manufacturer.name }}</div>
            <div class="desc">
              {{ manufacturer.address }}
            </div>
          </div>
        </div>
      </div>
      <div class="no-data text-center" v-else></div>
    </div>
    <div class="patient-input-wrapper inline-block" slot="reference">
      <div class="patient-input" prop="patient">
        <img
          class="circle-img mr-20"
          :src="manufacturer.avatarUrl"
          v-if="manufacturer.avatarUrl"
        />
        <div v-else class="mr-20 white-circle v-h-center">
          <img src="../assets/picture_grey.svg" />
        </div>
        <div>
          <div class="name">{{ manufacturer.name }}</div>
          <div class="desc">
            {{ manufacturer.address }}
          </div>
        </div>
        <img
          class="arrow"
          :class="visible ? 'rotate-180' : ''"
          src="../assets/arrow-down.svg"
        />
      </div>
    </div>
  </el-popover>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      visible: false,
      keywords: '',
      manufacturer: this.$store.state.manufacturer.selectedManufacturer,
      manufacturers: this.$store.state.manufacturer.manufacturers,
      keywordsTimer: ''
    }
  },
  mounted() {
    this.$store.dispatch('manufacturer/fetchManufacturer').then(() => {
      this.manufacturers = this.$store.state.manufacturer.manufacturers
      this.manufacturer = this.$store.state.manufacturer.selectedManufacturer
    })
  },
  watch: {
    keywords() {
      if (this.keywordsTimer) {
        clearTimeout(this.keywordsTimer)
      }
      this.keywordsTimer = setTimeout(this.search, 500)
    }
  },
  methods: {
    search() {
      return ApiService.GetManufactures()
        .then(response => {
          this.manufacturers = response.data.data
          if (this.keywords) {
            this.manufacturers = this.manufacturers.filter(item => {
              return (
                item.name.toLowerCase().indexOf(this.keywords.toLowerCase()) >
                -1
              )
            })
          }
        })
        .catch(() => {})
    },
    selectManufacturer(item) {
      this.manufacturer = item
      this.visible = false
      this.$store.commit(
        'manufacturer/SET_SELECTED_MANUFACTURER',
        this.manufacturer
      )
    }
  },
  beforeDestroy() {
    clearInterval(this.keywordsTimer)
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  height: 80px;
}
</style>
